import { ModuleType } from "../enums/module-type.enum";
import { PageType } from "../enums/page-type.enum";
import { RequestType } from "../enums/request-type.enum";
import { AbstractRequestDto } from "./abstract-request.dto";

export class RequestDataDto{
    finalData: AbstractRequestDto
    updatedAction:any
    pageUri:string;
    module: ModuleType;
    requestType:RequestType;
    pageType:PageType;
    queryParams:any;

    constructor(partial: Partial<RequestDataDto>) {
        Object.assign(this, partial);
    }
}